import React from 'react';
import PropTypes from 'prop-types';
import './MotoPhoto.scss';
import { tiresImages, generalConditionImages, brakesImages, driveImages } from '../../consts/conditionImages';
import { scoreColors } from '../../helpers/utils';
import MotoImage from '../../images/motoparts/Bike_Default.png';

const MotoPhoto = ({
  generalConditionScore,
  tiresScore,
  consumablesConditionScore,
}) => {
  const driveScoreEnum = scoreColors(consumablesConditionScore, true);
  const generalConditionScoreEnum = scoreColors(generalConditionScore, true);
  const tiresScoreEnum = scoreColors(tiresScore, true);
  const brakesScoreEnum = scoreColors(consumablesConditionScore, true);
  return (
    <div className="motorcycle-photo">
      <div className="row details__image">
        {driveScoreEnum && <img
          className="photo--overlapping photo__drive"
          src={driveImages[driveScoreEnum]}
          alt="drive"
                           />}
        {brakesScoreEnum && <img
          className="photo--overlapping photo__brakes"
          src={brakesImages[brakesScoreEnum]}
          alt="brakes"
                            />}
        {tiresScoreEnum && <img
          className="photo--overlapping photo__tires"
          src={tiresImages[tiresScoreEnum]}
          alt="tires"
                           />}
        {generalConditionScoreEnum && <img
          className="photo--overlapping"
          src={generalConditionImages[generalConditionScoreEnum]}
          alt="general_condition"
                                      />}
        <img src={MotoImage} alt="Motor" />
      </div>
    </div>
  );
};

MotoPhoto.propTypes = {
  consumablesConditionScore: PropTypes.number,
  generalConditionScore: PropTypes.number,
  tiresScore: PropTypes.number,
};

MotoPhoto.defaultProps = {
  consumablesConditionScore: null,
  generalConditionScore: null,
  tiresScore: null,
};

export default MotoPhoto;
